import gql from 'graphql-tag';

export const DELETE_TRACKED_PROPERTY_PERMISSIONS = gql`
    mutation deleteTrackedPropertyPermissions($uprn: String!) {
        deleteTrackedPropertyPermissions(uprn: $uprn)
    }
`;
